import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import StudentLoadIntentService from "../../src/Services/StudentLoadIntent.service";
import LookupGeneric from "./lookupGeneric";
const StudentLoadIntentLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return StudentLoadIntentService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return StudentLoadIntentService.search({
                query,
                active: true, // if StudentLoadIntent has an active field for this purpose
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(studentLoadIntent) {
            return _jsx("span", { children: studentLoadIntent.name });
        },
    });
};
export default StudentLoadIntentLookup;
